import { render, staticRenderFns } from "./DayViewer.vue?vue&type=template&id=3146874a&scoped=true&"
import script from "./DayViewer.vue?vue&type=script&lang=js&"
export * from "./DayViewer.vue?vue&type=script&lang=js&"
import style0 from "./DayViewer.vue?vue&type=style&index=0&id=3146874a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3146874a",
  null
  
)

export default component.exports